import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../../src/assets/images/logo-win-white.svg";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const SessionExpired = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const portalRef = useRef(null);
  const ssoPortal = useSelector((state) => state.sso?.ssoUserData?.Portal);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

  // ✅ Store portal info before Redux is cleared
  if (!portalRef.current && ssoPortal) {
    portalRef.current = ssoPortal;
  }
   if (!portalRef.current && ssoData) {
    portalRef.current = ssoData;
  }


  useEffect(() => {
    const expirationTime = Number(localStorage.getItem('sessionExpiration')) || 0;
    const hasExpired = localStorage.getItem('sessionExpired') === 'true';
    if (expirationTime > 0 && Date.now() >= expirationTime && hasExpired) {
      dispatch({ type: 'SESSION_EXPIRED' });
      dispatch({ type: 'CLEAR_REDUX_STATE' });
    }
  }, [dispatch]);

  const handleLogout = () => {
    const portal = portalRef.current;
    if (portal === "Highmark") {
      
       localStorage.removeItem("sessionExpired");
      if(ssoData?.domainInfo==="MyHighmarkIEL"){
           window.location.href = "https://auth.highmark.com/home?bmctx=631B249BF72C0BFF3661DEAAA9886192379CFE673ED1137D17410C3D2C757F8F6BCD8A3C1908273832F824E9E115FDCA6390AECEE064155A352EF8CEB28AA4DE&password=secure_string&respCookies=Secure;httponly;SameSite%3DNone;&contextType=external&miscCookies=Secure;httponly;SameSite%3DNone;&ssoCookie=Secure;httponly;SameSite%3DNone;&username=string&challenge_url=https:%2F%2Fauth.highmark.com%2F&request_id=-5676144048537218152&authn_try_count=0&locale=en_US&resource_url=https%253A%252F%252Fauth.highmark.com%252Fhmkoauth%252FuserConsent.jsp%253Fstate%253DZXBBOEhrOHRZdk0xT1dFNHZyT2VVZz09fmNjdGlucEFqSy91MEhISG9WdzNQOG1COHIyWVc0ckxsVEkwbmszT0NzN3E3MTFSemp1SW5pWFlUT21TY3hEeEVSdFFCWHQySURMaGU5MmxvTk05OHQvUUhCZW9kMWFqRzY4MFJuY3pCV2FZSk5QTzhTcTZGK05ubWtpOWxYWGRzVThPQlBuTWFiV1kweCtGVzJna3NZQkVMa2hRN25kY3hGWGRNYWRBZUpyWWFsSjFZMy96aHpvVmVrdEZSYjMzNm5PM2x4V3p5Zkg5azdGamtLUzYwaTlSeUNEZDBsV0hhUW9nTUVFLyt4MjIyWlBXdG9NelNQZkdJSWI3Y0VRM1MzcGEwdTI0U3J0Z1hoYUxYOGFlQnNRcStrVDBBazFYZkx3a0V6bW53Y0cyWWd1US8zZEVOcXBubXZGSERSRlJPbFUyZ0R2QjBQdFZtaU9RUkNBVU5KVDBFbmpLVnNRNllOYXBsNHBVY0hFWnpsQ0d4VDlzU3lSalpLd25UMjl5TW1pWmhCdDFCcUZ1VEg5VWRQTlgwc2lJdnpiZnovb3kvUG15dXoxMUN1MkE9%2526scopes%253Dopenid%252Boffline_access%252Bprofile%252Bresource.READ%252Bmember.external.read-only%252Bmember.external.update%2526client_id%253D4346795-5572-b394-577336f656c61466858347a656c773d3d";
        }
        else if(ssoData?.domainInfo==="allmyhealth"){
           window.location.href = "https://auth.allmyhealth.com/home?bmctx=631B249BF72C0BFF3661DEAAA98861924F2730C2597459EC902D19660439EBE89CF838BB360E94490B14E14E5931CDF0&password=secure_string&respCookies=Secure;httponly;SameSite%3DNone;&contextType=external&miscCookies=Secure;httponly;SameSite%3DNone;&ssoCookie=Secure;httponly;SameSite%3DNone;&username=string&challenge_url=https:%2F%2Fauth.allmyhealth.com%2F&request_id=-1611346045285673224&authn_try_count=0&locale=en_US&resource_url=https%253A%252F%252Fauth.allmyhealth.com%252Fhmkoauth%252FuserConsent.jsp%253Fstate%253DS3BnKzArUi9lNnk2T0UvaXU3L1NpZz09fklpZEY0YU9ySUdUc3F2elc5K3dEMmpqeVo5WVd3N1k0TXZmaFZvMW5Kd0lHRHoxbVI4WG9HdjVOQjVXMzg0NUw2ZFB1QXlGUWZ1emkxV29jS2pibTRZeHhpdzc0aFkrdFRDN1dCbUc5azdIVWozYlpDWjVkQWlXTDQ1dHlsYldjWGtTbDB6cWMvSkdKcExNYUhrZTJyZGs4US9rYWNFNnBUQy9KSnFSaG9KM1pWc2plY0RaTGl2MjF6WEp3Zk1SMkwwWEpGdFdTWTlkZlhUbDRVYW85TlpBQ3FRRkRVeTdOUm5QS1dKM0pJcnVOS2tSOXd6R2gyekoxeWJoamRKdWJ4eWtKd1hta25EK1kvaXNTaFFtTDlIaVI3cGJWQ0hMaHAxNUtacmE1UnhmUTFuQmlhMFVoelo4bU1QOWpvanpRR2ovNVJEc1U1aU9Kc3FLemhLUDZCMG56R0NHaUdNOVBsSVJlcXp3dnBtV0cxVjI5b3M5UXJwajN2a2ttcmNZOFd1UzFuM25UMThuRFhnNTVQTjdnS09QZWViUTVIbzRtUmFiQlJDdERGUDg9%2526scopes%253Dopenid%252Boffline_access%252Bprofile%252Bresource.READ%252Bmember.external.read-only%252Bmember.external.update%2526client_id%253D7a2b6d4-d556-8715-67a4b47694e313059724464496a773d3d"
        }
      localStorage.removeItem('sessionExpiration');
      localStorage.removeItem("sessionExpired");
      localStorage.removeItem('AccessToken');
      dispatch({ type: 'LOGOUT' });
    } else {
      localStorage.removeItem('sessionExpiration');
      localStorage.removeItem("sessionExpired");
      localStorage.removeItem('AccessToken');
      dispatch({ type: 'LOGOUT' });
      navigate('/login');
    }
  };
  

  return (
    <div className="outer-container">
      <div className="session-container">
        <div className="logo-container">
          {isHighmarkPortal ? <></> :
           <img src={logo} className="session-logo" alt="WIN Logo" /> }
        </div>

        {/* Hidden input for deploy popup handling */}
        <input type="hidden" id="isSessionexpirepage" value="true" />

        <h1 className="session-title">{t("sessionexpired")}</h1>
        <p className="session-message">{t("dessession")}</p>

        {/* Button handles redirect properly */}
        <button className="win-btn-secondary" onClick={handleLogout}>
          {t("login")}
        </button>
      </div>
    </div>
  );
};

export default SessionExpired;
